const FETCH_PRODUCTS = 'products/fetchProducts';
const FETCH_BY_ID = 'products/fetchById';
const SET_LOADING_TRUE = 'products/loadingTrue';
const SET_LOADING_FALSE = 'products/loadingFalse';

export { FETCH_PRODUCTS, FETCH_BY_ID, SET_LOADING_FALSE, SET_LOADING_TRUE };
